import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Transformation() {
  const benefits = ['Más de 100 recetas.', 'Paso a paso.', 'Ingredientes argentinos.', 'Recetas fáciles.', 'Ideal para diabetes tipo 2.', 'Ideal para prediabetes.', 'Ideal para resistencia a la insulina.'];
  return <section className="py-24 md:py-32 px-6 bg-gray-50" data-id="element-182">
      <div className="max-w-5xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-184">
          <h2 className="text-4xl md:text-6xl font-serif font-black text-gray-900 leading-tight mb-8" data-id="element-185">
            POR ESO CREAMOS LA <br data-id="element-186" />
            <span className="text-primary" data-id="element-187">
              ENCICLOPEDIA GLUKO LIBRE ARGENTINA
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-188">
            Una guía definitiva diseñada para devolverte la alegría de sentarte
            a la mesa. Sin ingredientes raros, sin preparaciones imposibles.
            Solo comida real, deliciosa y segura para tu salud.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-189">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-lg shadow-gray-200/50 border border-gray-100 flex items-center gap-4 hover:-translate-y-1 transition-transform duration-300" data-id="element-190">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-191">
                <CheckCircle2 className="w-6 h-6 text-primary" data-id="element-192" />
              </div>
              <span className="text-xl font-bold text-gray-800 leading-tight" data-id="element-193">
                {benefit}
              </span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-194">
          <Button data-id="element-195">QUIERO VOLVER A DISFRUTAR LA COMIDA</Button>
        </div>
      </div>
    </section>;
}